export default "__VITE_ASSET__w78c_CEp__"